import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { InitiatePaymentInput, InitiatePaymentResponse, PaytmCallbackData } from "@models/payment.model";

import { InitiatePhonePePaymentInput, PhonePeResponse, PhonePeResponseV2 } from "@models/phonepe.model";

@Injectable({
    providedIn: "root",
})
export class PaymentService {
    constructor(private http: HttpClient) {}

    public initiatePayment(paymentBody: InitiatePaymentInput): Observable<InitiatePaymentResponse> {
        return this.http.post(
            `${environment.apiUrlBasePath}/payment/paytm/initiatePayment`,
            paymentBody,
        ) as Observable<InitiatePaymentResponse>;
    }

    public verifyCallbackResponse(data: PaytmCallbackData): Observable<string> {
        return this.http.post(
            `${environment.apiUrlBasePath}/payment/paytm/verifyCallbackResponse`,
            data,
        ) as Observable<string>;
    }

    /** PhonePe API to initiate paymentPage **/
    public initiatePhonePePayment(data: InitiatePhonePePaymentInput): Observable<{ url: string }> {
        return this.http.post<{ url: string }>(`${environment.apiUrlBasePath}/phonepe/pay`, data);
    }

    /** Verify Status After Redirecting to Order Success Page **/
    public getPhonePePaymentStatus(merchantTransactionId: string): Observable<{
        responseData: PhonePeResponse | PhonePeResponseV2;
        orderID: number;
    }> {
        return this.http.get<{
            responseData: PhonePeResponse | PhonePeResponseV2;
            orderID: number;
        }>(`${environment.apiUrlBasePath}/phonepe/payment/${merchantTransactionId}/status`);
    }
}
